"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.a = useOnClickOutside;

var _react = require("react");

function useOnClickOutside(selector, handler) {
  (0, _react.useEffect)(function () {
    var listener = function listener(event) {
      var target = event.target.className;

      if (typeof target.includes === "function" && target.includes(selector)) {
        return;
      }

      handler(event);
    };

    document.addEventListener("mouseup", listener);
    document.addEventListener("touchend", listener);
    return function () {
      document.removeEventListener("mouseup", listener);
      document.removeEventListener("touchend", listener);
    };
  }, [selector, handler]);
}